import { useReducer } from 'react';

export const defaultFieldState = {
  cardNumber: { touched: false, value: null, error: null },
  nameOnCard: { touched: false, value: null, error: null },
  securityCode: { touched: false, value: null, error: null },
  expiryMonth: { touched: false, value: null, error: null },
  expiryYear: { touched: false, value: null, error: null },
};

export const FIELD_ACTIONS = {
  SET_FIELD_TOUCHED: 'SET_FIELD_TOUCHED',
  SET_FIELD_VALUE: 'SET_FIELD_VALUE',
  SET_FIELD_ERROR: 'SET_FIELD_ERROR',
  RESET: 'RESET',
};

export const REQUIRED_FIELD_ERROR_KEY = 'missing';
export const INVALID_FIELD_ERROR_KEY = 'invalid';

export const fieldReducer = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case FIELD_ACTIONS.SET_FIELD_TOUCHED: {
      return { ...state, [payload.name]: { ...state[payload.name], touched: true } };
    }
    case FIELD_ACTIONS.SET_FIELD_VALUE: {
      return { ...state, [payload.name]: { ...state[payload.name], value: payload.value, touched: true } };
    }
    case FIELD_ACTIONS.SET_FIELD_ERROR: {
      const error = state[payload.name].touched ? payload.error : null;
      return { ...state, [payload.name]: { ...state[payload.name], error } };
    }
    case FIELD_ACTIONS.RESET: {
      return defaultFieldState;
    }
    default: {
      return state;
    }
  }
};

export default () => useReducer(fieldReducer, defaultFieldState);
